module.exports = __webpack_public_path__ + "img/targetRed.fb9d0c26.jpg";